import { genericCallWithBodyAndResponseDecoded, genericGetWithParameters } from "./Networking";

export const searchBankNotesForPickAndPack = async (customerId, fromDate, toDate, status = '', deliveryStatus = '', settlementStatus = '', page, pageSize) => {
    try {
        const params = {
            CustomerId: customerId,
            FromDate: fromDate,
            ToDate: toDate,
            Page: page,
            PageSize: pageSize,
            "Status": status,
            DeliveryStatus: deliveryStatus,
            SettlementStatus: settlementStatus
        };
        const response = await genericGetWithParameters('BNOrder/SearchBankNotesForPickAndPack', params);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const getBankNoteOrder = async (orderNumber) => {
    try {
        const params = {
            orderNumber: orderNumber,
        }

        const response = await genericGetWithParameters(
            'BNOrder/GetBankNoteOrder',
            params,
        )

        return response
    } catch (error) {
        console.error(error)
    }
};

export const updateOrderStatus = async (orderNumber, status, deliveryStatus, settlementStatus, updateToken) => {
    var method = 'POST';
    var apiName = 'BNOrder/UpdateOrderStatus'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'OrderNumber': orderNumber,
            'Status': status,
            'DeliveryStatus': deliveryStatus,
            'settlementStatus': settlementStatus,
            'UpdateToken': updateToken
        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export const updateProcessingDenominations = async (orderNumber, updateJson, updateToken) => {
    var method = 'POST';
    var apiName = 'BNOrder/UpdateProcessingDenominations'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'OrderNo': orderNumber,
            'UpdateJson': JSON.stringify(updateJson),
            'UpdateToken': updateToken

        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export async function getOrdersForSettlements(customerID, currencyID, lockedSide, settlementId, page, items){
    try {
        let params = {
            'customerId': customerID,
            'currencyId': currencyID,
            'buySell': lockedSide,
            'settlementId': settlementId,
            'page': page,
            'items': items,
        };
        let response = await genericGetWithParameters('BNOrder/GetOrdersForSettlements',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const confirmPickAndPack = async (orderNumbers, deliveryStatus, orderReference) => {
    var method = 'POST';
    var apiName = 'BNOrder/ConfirmPickAndPack'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'OrderNumbers': orderNumbers,
            'DeliveryStatus': deliveryStatus,
            'OrderReference': orderReference
        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export const getOrdersForPickAndPack = async (orderNo, outTransit, page, pageSize) => {
    try {
        const params = {
            'orderNo': orderNo,
            'outTransit': outTransit,
            'page': page,
            'pageSize': pageSize
        };
        const response = await genericGetWithParameters('BNOrder/GetOrdersForPickAndPack', params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const getDeliveryInformation = async (orderNumber) => {
    try {
        const params = {
            orderNumber: orderNumber,
        }

        const response = await genericGetWithParameters(
            'BNOrder/GetDeliveryInformation',
            params,
        )

        return response
    } catch (error) {
        console.error(error)
    }
};

export const confirmReceivedOrder = async (orderNumber) => {
    var method = 'POST';
    var apiName = 'BNOrder/ConfirmReceivedOrder'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'OrderNumber': orderNumber
        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export const saveVaultReconciliation = async (vaultReconciliationId, vaultReconciliationJson, updateToken) => {
    var method = 'POST';
    var apiName = 'BNOrder/SaveVaultReconciliation'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'VaultReconciliationId': vaultReconciliationId,
            'VaultReconciliationJson': JSON.stringify(vaultReconciliationJson),
            'UpdateToken': updateToken

        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export const searchVaultReconciliation = async (vaultId = 0, status, fromDate, toDate, page, pageSize) => {
    try {
        const params = {
            VaultId: vaultId,
            Status: status,
            FromDate: fromDate,
            ToDate: toDate,
            Page: page,
            PageSize: pageSize
        };
        const response = await genericGetWithParameters('BNOrder/SearchVaultReconciliation', params);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const getBankNotesReconciliation = async (reconciliationId) => {
    try {
        const params = {
            reconciliationId: reconciliationId,
        }

        const response = await genericGetWithParameters(
            'BNOrder/GetReconciliation',
            params,
        )

        return response
    } catch (error) {
        console.error(error)
    }
};

export const deleteVaultReconciliation = async (vaultReconciliationId, updateToken) => {
    var method = 'POST';
    var apiName = 'BNOrder/DeleteVaultReconciliation'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'VaultReconciliationId': vaultReconciliationId,
            'UpdateToken': updateToken

        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export const voidOrder = async (orderNumber) => {
    var method = 'POST';
    var apiName = 'BNOrder/VoidOrder'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'BNOrderNo': orderNumber
        });
        return response;
    } catch (error) {
        console.error(error)
    }
}

export const getStockRealign = async (vaultID, currencyID) => {
    try {
        const params = {
            vaultID: vaultID,
            currencyId: currencyID
        }

        const response = await genericGetWithParameters(
            'BNOrder/GetStockRealign',
            params,
        )

        return response
    } catch (error) {
        console.error(error)
    }
};

export async function saveReasignStock(json) {
  const method = 'POST'
  const apiName = 'BNOrder/SaveStockRealign'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    json,
  )
  return response
}